export enum ProcessStage {
    Draft = 0,
    Active = 1,
    Completed = 2,
    Cancelled = 3,
    Pending = 4
}